// ------------------------------------------------------------
// Redux Store Configuration
// ------------------------------------------------------------
// This file sets up the Redux store for the application.
// It integrates:
// 1. Global slice reducer for app-wide state.
// 2. RTK Query API service reducer and middleware for data fetching,
//    caching, and invalidation.
// ------------------------------------------------------------

import { configureStore } from "@reduxjs/toolkit";
import { apiService } from "./slices/apiSlice";
import globalReducer from "./slices";

/**
 * store - Redux store
 * ------------------------------------------------------------
 * Configures the Redux store with:
 * - globalReducer: Application-wide state
 * - apiService.reducer: RTK Query reducer for API caching
 * - Middleware: Includes apiService.middleware for RTK Query features
 */
export const store = configureStore({
  reducer: {
    /** Global state reducer */
    global: globalReducer,

    /** RTK Query API reducer */
    [apiService.reducerPath]: apiService.reducer,
  },

  /** Middleware setup including RTK Query middleware */
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiService.middleware),
});
